import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    restaurantSwitcherContainer: {
      display: 'flex',
      backgroundColor: '#EDE9E2',
      borderRadius: '12px',
      alignItems: 'center',
      minHeight: '64px',
      boxSizing: 'border-box',
      padding: '12px 10px',
      color: theme.colors.BLACK,
      gap: '8px',
      margin: '22px 0 20px 0',
      cursor: 'pointer',
      userSelect: 'none',
      position: 'relative',
      transition: 'background-color 0.15s ease',
      '&:hover': {
        backgroundColor: '#E9E5DF',
      },
    },
    textOverflow: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'block',
      fontSize: '15px',
      fontWeight: 500,
    },
    restaurantDropdownArrow: {
      marginLeft: 'auto',
      color: theme.colors.BLACK,
      transitionDuration: '0.1s',
      flexShrink: 0,
      marginRight: '12px',
    },
    accountMenuContent: {
      pointerEvents: 'auto',
      backgroundColor: theme.colors.LINEN,
      padding: '12px',
      borderRadius: '20px',
      lineHeight: 'normal',

      [theme.breakpoints.down('sm')]: {
        marginLeft: '20px',
      },
    },
    navigationLinks: {
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      maxHeight: '500px',
      overflowY: 'scroll',
    },
    navigationLink: {
      padding: '6px 12px',
      borderRadius: '12px',
      cursor: 'pointer',
      userSelect: 'none',
      display: 'flex',
      gap: '16px',
      alignItems: 'center',
      transition: 'all 0.1s',
      lineHeight: '30px',
      marginTop: '4px',
      flexShrink: 0,

      '&:hover': {
        backgroundColor: 'rgba(49, 49, 49, 0.04)',
      },
    },
    divider: {
      marginTop: '8px',
      borderColor: '#E9E9E9',
    },
    logoContainer: {
      padding: '6px',
      borderRadius: '8px',
      background: '#FAD14A',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      flexShrink: 0,
    },
    restaurantAddress: {
      fontSize: '15px',
      color: theme.colors.smoke,
    },
    newLabel: {
      color: theme.colors.black,
      textTransform: 'uppercase',
      backgroundColor: '#FCFCCF',
      fontWeight: theme.fontWeights.medium,
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
      height: '24px',
      padding: '0 6px',
      borderRadius: '4px',
      letterSpacing: 1.5,
    },
    chip: {
      padding: '4px 10px',
      borderRadius: '20px',
      background: '#FEFED2',
      // border: '1px solid #E8E4B8',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      flexShrink: 0,
      color: '#0C0C0C',
      fontFamily: "'General Grotesque', Inter, 'Helvetica', 'sans-serif'",
      fontSize: '14px',
      lineHeight: 'normal',
      fontStyle: 'normal',
      fontWeight: 400,
      cursor: 'pointer',
      transition: 'filter 0.2s ease',
      '&:hover': {
        filter: 'brightness(0.97)',
      },
    },
    chipDisabled: {
      background: '#DBDBDB',
      border: '1px solid #6E6E6D',
      color: '#6E6E6D',
      fontSize: '14px',
      lineHeight: 'normal',
      fontStyle: 'normal',
      fontWeight: 400,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      '&:hover': {
        filter: 'brightness(0.95)',
      },
    },
    restaurantSwitcherContainerActive: {
      position: 'relative',
      zIndex: 1301, // custom handling of popover so we can have the highlighted restaurant switcher focus
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      transition: 'all 0.3s ease',
      backgroundColor: '#F6F2EE',
    },
  }),
  { name: 'RestaurantSwitcher' },
);

export default useStyles;
